import { useEffect } from 'react';
import { useIsMounted } from '@toss/react';
import { useRouter } from 'next/router';
import { appendTrackingId, appendUTMParams, parseTrackingId, TRACKING_ID_PARAM } from '@/utils/analytics';
interface Props {
  webFormUrl: string;
  className?: string;
}
export function SalesMapEmbed({
  webFormUrl,
  className
}: Props) {
  const mounted = useIsMounted();
  const router = useRouter();

  // 문의 CTA 가 내부 라우팅으로 이 폼을 열 때 쿼리로 넘겨준 클릭 식별자.
  // 클릭 없이 인라인 임베드된 사용처(랜딩 Pricing)에는 없고, 그 경우 그냥 붙지 않는다.
  // 공개 URL 로 오는 값이라 형식이 맞는 것만 통과시킨다 — 임의 문자열을 그대로 폼에
  // 실어 보내면 제출 데이터가 오염되고 링크에 담긴 값이 외부로 나간다.
  const trackingId = parseTrackingId(router.query[TRACKING_ID_PARAM]);
  useEffect(() => {
    if (mounted) {
      const script = document.createElement('script');
      script.id = 'loadFormScript';
      script.src = 'https://salesmap.kr/web-form-loader-v3.js';
      script.async = true;
      script.onload = () => {
        // @ts-expect-error -- SalesMap 외부 스크립트가 주입하는 전역 객체로 타입 정의 없음
        window.SmFormSettings.loadForm();
      };
      document.body.appendChild(script);
    }
  }, [mounted]);
  return <div id="salesmap-web-form"
  // 저장/현재 UTM + 클릭 식별자(tracking_id)를 폼 URL 에 실어 attribution 전달.
  // 두 사용처 모두 <NoSSR> 로 감싸 client 전용 렌더라 hydration mismatch 없음.
  data-web-form={appendTrackingId(appendUTMParams(webFormUrl), trackingId)} className={className} data-sentry-component="SalesMapEmbed" data-sentry-source-file="SalesMapEmbed.tsx"></div>;
}